import { FC } from 'react';

import WorkTripsCalendarView from 'routes/client/work-trips/components/WorkTripsCalendarView';

import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => (
  <WorkTripsCalendarView
    Wrapper={InnerWrapper}
    entityName="my-work-trips-calendar"
    showUserAndGroupFilters={false}
  />
);

export default Screen;
